@if (version > 1) {
    <vn-menu-item [item]="item" [section]="MenuSection.Menu" linkClass="am-logout" textClass="logout-txt" [processClick]="false" (click)="logout()" />
} @else {
    @if (useFastIconType) {
        <vn-menu-item
            [item]="item"
            [section]="MenuSection.Menu"
            [displayMode]="MenuDisplayMode.FastIcon"
            badgePosition="FastIcon"
            linkClass="list-nav-link"
            iconClass="ui-icon ui-icon-size-xl"
            badgeClass="badge-offset"
            textClass="list-nav-txt"
            [text]="wait ? msg.PleaseWait : item.text || msg.SignOut"
            [processClick]="false"
            (click)="logout()" />
    } @else {
        <vn-menu-item
            [item]="item"
            [section]="MenuSection.Menu"
            [displayMode]="MenuDisplayMode.Icon"
            badgePosition="icon"
            linkClass="list-nav-link"
            iconClass="ui-icon ui-icon-size-xl"
            badgeClass="badge-offset"
            textClass="list-nav-txt"
            [text]="wait ? msg.PleaseWait : item.text || msg.SignOut"
            [processClick]="false"
            (click)="logout()" />
    }
}
